/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."
import dayjs from "dayjs"

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import ComboBox from "../../../components/ComboBox"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import sogoYusoKaigiService from "../../../service/budget/sogoYusoKaigi/sogoYusoKaigiService"
import {
  TBusyoBudgetAchievementlistGetReq,
  TNinusiUriageListGetRes,
  TBusyoBudgetAchievementlistPutReq,
  TNinusiDokoListPutReq,
  TBudgetAchievementListGetRes,
  T予算実績,
  T荷主売上一覧,
  TSogoYusoKaigiPrintGetReq,
} from "../../../service/budget/sogoYusoKaigi/TSogoYusoKaigi"
import { 予算_実績メニューコード } from "../../../constant/menuCode"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { decimalPlus, quotOrZero } from "../../../ts/util/decimalUtil"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { RootState } from "../../../globalStore/rootreducer"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { TApiResponse } from "../../../service/TApiResponse"
import {
  showInfoToast,
  showWarningToast,
} from "../../../components/CustomToast"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import dateUtil from "../../../ts/util/dateUtil"
import UpdateGekkanSyukeiTextModal from "./UpdateGekkanSyukeiTextModal"
import {
  create総合輸送会議部所実績合算Data,
  orderBy総合輸送会議予算実績,
  予算実績列項目文字列,
} from "./sogoYusoKaigiConstant"

/**
 * 総合輸送会議　荷主予算実績
 * @returns
 */
const BusyoBudgetAchievement = () => {
  const history = useHistory()
  const location = useLocation()
  const 当営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  const disPatch: AppDispatch = useDispatch()
  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "BusyoBudgetAchievement_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        // 予算実績行の数値と達成率行のパーセンテージを表示するため文字列に変換
        年間金額str: (i: T予算実績) => cnvUriageStr(i.年間金額 ?? 0, i.項目),
        上期金額str: (i: T予算実績) => cnvUriageStr(i.上期金額 ?? 0, i.項目),
        下期金額str: (i: T予算実績) => cnvUriageStr(i.下期金額 ?? 0, i.項目),
        金額４月str: (i: T予算実績) => cnvUriageStr(i.金額４月, i.項目),
        金額５月str: (i: T予算実績) => cnvUriageStr(i.金額５月, i.項目),
        金額６月str: (i: T予算実績) => cnvUriageStr(i.金額６月, i.項目),
        金額７月str: (i: T予算実績) => cnvUriageStr(i.金額７月, i.項目),
        金額８月str: (i: T予算実績) => cnvUriageStr(i.金額８月, i.項目),
        金額９月str: (i: T予算実績) => cnvUriageStr(i.金額９月, i.項目),
        金額１０月str: (i: T予算実績) => cnvUriageStr(i.金額１０月, i.項目),
        金額１１月str: (i: T予算実績) => cnvUriageStr(i.金額１１月, i.項目),
        金額１２月str: (i: T予算実績) => cnvUriageStr(i.金額１２月, i.項目),
        金額１月str: (i: T予算実績) => cnvUriageStr(i.金額１月, i.項目),
        金額２月str: (i: T予算実績) => cnvUriageStr(i.金額２月, i.項目),
        金額３月str: (i: T予算実績) => cnvUriageStr(i.金額３月, i.項目),
      },
    })
  /**
   * 荷主動向用collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createNinusiDokoCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TBusyoBudgetAchievementlistGetReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBusyoBudgetAchievementlistGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const cond = currentSearchCondition
      cond.年 = dayjs(currentSearchCondition.年月).year()
      cond.月 = dayjs(currentSearchCondition.年月).month() + 1
      cond.部所コード = currentSearchCondition.部所コード

      const inner部所名 =
        部所ItemSource?.find((i) => i.部所コード === cond.部所コード)
          ?.部所略称 ?? ""

      const res =
        await new sogoYusoKaigiService().getBusyoBudgetAchievementList(cond)
      setPreSearchCondition(cond)
      const 予算実績data = res.data.予算実績
      const 荷主売上data = res.data.荷主売上
      const 荷主動向data = res.data.主要荷主動向

      const BudgetResData: T予算実績[] = []
      const NinusiResData: T荷主売上一覧[] = []
      if (荷主売上data) {
        荷主売上data.forEach((d: TNinusiUriageListGetRes) => {
          let 月 = (dayjs(d.年月 + "/01").month() + 1).toString()
          let rowData: T荷主売上一覧 = {
            部所コード: "",
            部所名: "",
            荷主コード: "",
            荷主名: "",
            金額１月: 0,
            金額２月: 0,
            金額３月: 0,
            金額４月: 0,
            金額５月: 0,
            金額６月: 0,
            金額７月: 0,
            金額８月: 0,
            金額９月: 0,
            金額１０月: 0,
            金額１１月: 0,
            金額１２月: 0,
            年間金額: 0,
            上期金額: 0,
            下期金額: 0,
          }
          rowData.荷主名 = d.荷主略称1
          rowData.荷主コード = d.荷主コード
          rowData.部所名 = d.部所名
          rowData.部所コード = d.部所コード
          switch (月) {
            case "4":
              rowData.荷主名 = d.荷主略称1
              rowData.荷主コード = d.荷主コード
              rowData.部所名 = d.部所名
              rowData.部所コード = d.部所コード
              rowData.金額４月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "5":
              rowData.金額５月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "6":
              rowData.金額６月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "7":
              rowData.金額７月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "8":
              rowData.金額８月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "9":
              rowData.金額９月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "10":
              rowData.金額１０月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "11":
              rowData.金額１１月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "12":
              rowData.金額１２月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "1":
              rowData.金額１月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "2":
              rowData.金額２月 = d.売上額
              NinusiResData.push(rowData)
              break
            case "3":
              rowData.金額３月 = d.売上額
              NinusiResData.push(rowData)
              break
            default:
              break
          }
        })
        // 部所・項目でGROUP BY的な処理
        const NinusiGridRowData = NinusiResData.reduce(
          (result: T荷主売上一覧[], current) => {
            const element = result.find(
              (r) => r.荷主コード === current.荷主コード
            )
            if (element) {
              let 上期金額 = decimalPlus([
                element.上期金額 ?? 0,
                current.金額４月,
                current.金額５月,
                current.金額６月,
                current.金額７月,
                current.金額８月,
                current.金額９月,
              ])
              let 下期金額 = decimalPlus([
                element.下期金額 ?? 0,
                current.金額１０月,
                current.金額１１月,
                current.金額１２月,
                current.金額１月,
                current.金額２月,
                current.金額３月,
              ])
              element.上期金額 = 上期金額
              element.下期金額 = 下期金額
              element.年間金額 = decimalPlus([上期金額, 下期金額])
              element.金額４月 = decimalPlus([
                element.金額４月,
                current.金額４月,
              ])
              element.金額５月 = decimalPlus([
                element.金額５月,
                current.金額５月,
              ])
              element.金額６月 = decimalPlus([
                element.金額６月,
                current.金額６月,
              ])
              element.金額７月 = decimalPlus([
                element.金額７月,
                current.金額７月,
              ])
              element.金額８月 = decimalPlus([
                element.金額８月,
                current.金額８月,
              ])
              element.金額９月 = decimalPlus([
                element.金額９月,
                current.金額９月,
              ])
              element.金額１０月 = decimalPlus([
                element.金額１０月,
                current.金額１０月,
              ])
              element.金額１１月 = decimalPlus([
                element.金額１１月,
                current.金額１１月,
              ])
              element.金額１２月 = decimalPlus([
                element.金額１２月,
                current.金額１２月,
              ])
              element.金額１月 = decimalPlus([
                element.金額１月,
                current.金額１月,
              ])
              element.金額２月 = decimalPlus([
                element.金額２月,
                current.金額２月,
              ])
              element.金額３月 = decimalPlus([
                element.金額３月,
                current.金額３月,
              ])
            } else {
              current.上期金額 = decimalPlus([
                current.金額４月,
                current.金額５月,
                current.金額６月,
                current.金額７月,
                current.金額８月,
                current.金額９月,
              ])
              current.下期金額 = decimalPlus([
                current.金額１０月,
                current.金額１１月,
                current.金額１２月,
                current.金額１月,
                current.金額２月,
                current.金額３月,
              ])
              current.年間金額 = decimalPlus([
                current.上期金額,
                current.下期金額,
              ])
              result.push(current)
            }
            return result
          },
          []
        )
        // 検索結果をstateにセット
        setGridData({ data: createCollectionView(NinusiGridRowData, pageSize) })
      } else {
        setGridData({ data: createCollectionView([], pageSize) })
      }
      // 予算実績　月ごとのフィールドを作成して格納する
      予算実績data.forEach((d: TBudgetAchievementListGetRes) => {
        let 月 = (dayjs(d.年月 + "/01").month() + 1).toString()
        let rowData: T予算実績 = {
          年月: "",
          部所コード: "",
          部所名: "",
          項目: "",
          金額１月: 0,
          金額２月: 0,
          金額３月: 0,
          金額４月: 0,
          金額５月: 0,
          金額６月: 0,
          金額７月: 0,
          金額８月: 0,
          金額９月: 0,
          金額１０月: 0,
          金額１１月: 0,
          金額１２月: 0,
          年間金額: 0,
          上期金額: 0,
          下期金額: 0,
        }
        rowData.部所名 = d.部所名
        rowData.部所コード = d.部所コード
        rowData.項目 = d.項目
        rowData.報告テキスト１ = d.報告テキスト１
        rowData.報告テキスト２ = d.報告テキスト２
        rowData.報告テキスト３ = d.報告テキスト３
        rowData.報告テキスト４ = d.報告テキスト４
        rowData.報告テキスト５ = d.報告テキスト５
        switch (月) {
          case "4":
            rowData.金額４月 = d.金額
            BudgetResData.push(rowData)
            break
          case "5":
            rowData.金額５月 = d.金額
            BudgetResData.push(rowData)
            break
          case "6":
            rowData.金額６月 = d.金額
            BudgetResData.push(rowData)
            break
          case "7":
            rowData.金額７月 = d.金額
            BudgetResData.push(rowData)
            break
          case "8":
            rowData.金額８月 = d.金額
            BudgetResData.push(rowData)
            break
          case "9":
            rowData.金額９月 = d.金額
            BudgetResData.push(rowData)
            break
          case "10":
            rowData.金額１０月 = d.金額
            BudgetResData.push(rowData)
            break
          case "11":
            rowData.金額１１月 = d.金額
            BudgetResData.push(rowData)
            break
          case "12":
            rowData.金額１２月 = d.金額
            BudgetResData.push(rowData)
            break
          case "1":
            rowData.金額１月 = d.金額
            BudgetResData.push(rowData)
            break
          case "2":
            rowData.金額２月 = d.金額
            BudgetResData.push(rowData)
            break
          case "3":
            rowData.金額３月 = d.金額
            BudgetResData.push(rowData)
            break
          default:
            break
        }
      })

      // 部所・項目でGROUP BY的な処理
      const gridRowData = BudgetResData.reduce(
        (result: T予算実績[], current) => {
          const element = result.find(
            (r) => r.部所名 === current.部所名 && r.項目 === current.項目
          )
          if (element) {
            let 上期金額 = decimalPlus([
              element.上期金額 ?? 0,
              current.金額４月,
              current.金額５月,
              current.金額６月,
              current.金額７月,
              current.金額８月,
              current.金額９月,
            ])
            let 下期金額 = decimalPlus([
              element.下期金額 ?? 0,
              current.金額１０月,
              current.金額１１月,
              current.金額１２月,
              current.金額１月,
              current.金額２月,
              current.金額３月,
            ])
            element.上期金額 = 上期金額
            element.下期金額 = 下期金額
            element.年間金額 = decimalPlus([上期金額, 下期金額])
            element.金額４月 = decimalPlus([element.金額４月, current.金額４月])
            element.金額５月 = decimalPlus([element.金額５月, current.金額５月])
            element.金額６月 = decimalPlus([element.金額６月, current.金額６月])
            element.金額７月 = decimalPlus([element.金額７月, current.金額７月])
            element.金額８月 = decimalPlus([element.金額８月, current.金額８月])
            element.金額９月 = decimalPlus([element.金額９月, current.金額９月])
            element.金額１０月 = decimalPlus([
              element.金額１０月,
              current.金額１０月,
            ])
            element.金額１１月 = decimalPlus([
              element.金額１１月,
              current.金額１１月,
            ])
            element.金額１２月 = decimalPlus([
              element.金額１２月,
              current.金額１２月,
            ])
            element.金額１月 = decimalPlus([element.金額１月, current.金額１月])
            element.金額２月 = decimalPlus([element.金額２月, current.金額２月])
            element.金額３月 = decimalPlus([element.金額３月, current.金額３月])
          } else {
            current.上期金額 = decimalPlus([
              current.金額４月,
              current.金額５月,
              current.金額６月,
              current.金額７月,
              current.金額８月,
              current.金額９月,
            ])
            current.下期金額 = decimalPlus([
              current.金額１０月,
              current.金額１１月,
              current.金額１２月,
              current.金額１月,
              current.金額２月,
              current.金額３月,
            ])
            current.年間金額 = decimalPlus([current.上期金額, current.下期金額])
            result.push(current)
          }
          return result
        },
        []
      )

      const 共通項目 = {
        年月: "",
        部所コード: "",
        部所名: inner部所名,
      }

      // 合計グリッドの作成
      const summaryData: T予算実績[] = []
      summaryData.push(
        create総合輸送会議部所実績合算Data(
          gridRowData,
          予算実績列項目文字列.予算,
          共通項目
        )
      )
      summaryData.push(
        create総合輸送会議部所実績合算Data(
          gridRowData,
          予算実績列項目文字列.当年実績,
          共通項目
        )
      )
      summaryData.push(
        create総合輸送会議部所実績合算Data(
          gridRowData,
          予算実績列項目文字列.前年実績,
          共通項目
        )
      )
      summaryData.push(
        create総合輸送会議部所実績合算Data(
          gridRowData,
          予算実績列項目文字列.運行実績,
          共通項目
        )
      )

      summaryData.push({
        ...共通項目,
        項目: "達成率",
        年間金額: quotOrZero(
          summaryData[1].年間金額!,
          summaryData[0].年間金額!
        ),
        上期金額: quotOrZero(
          summaryData[1].上期金額!,
          summaryData[0].上期金額!
        ),
        下期金額: quotOrZero(
          summaryData[1].下期金額!,
          summaryData[0].下期金額!
        ),
        金額４月: quotOrZero(summaryData[1].金額４月, summaryData[0].金額４月),
        金額５月: quotOrZero(summaryData[1].金額５月, summaryData[0].金額５月),
        金額６月: quotOrZero(summaryData[1].金額６月, summaryData[0].金額６月),
        金額７月: quotOrZero(summaryData[1].金額７月, summaryData[0].金額７月),
        金額８月: quotOrZero(summaryData[1].金額８月, summaryData[0].金額８月),
        金額９月: quotOrZero(summaryData[1].金額９月, summaryData[0].金額９月),
        金額１０月: quotOrZero(
          summaryData[1].金額１０月,
          summaryData[0].金額１０月
        ),
        金額１１月: quotOrZero(
          summaryData[1].金額１１月,
          summaryData[0].金額１１月
        ),
        金額１２月: quotOrZero(
          summaryData[1].金額１２月,
          summaryData[0].金額１２月
        ),
        金額１月: quotOrZero(summaryData[1].金額１月, summaryData[0].金額１月),
        金額２月: quotOrZero(summaryData[1].金額２月, summaryData[0].金額２月),
        金額３月: quotOrZero(summaryData[1].金額３月, summaryData[0].金額３月),
        報告テキスト１: "",
        報告テキスト２: "",
        報告テキスト３: "",
        報告テキスト４: "",
        報告テキスト５: "",
      })

      setSummaryGridData({
        data: createSummaryCollectionView(
          orderBy総合輸送会議予算実績(summaryData),
          pageSize
        ),
      })
      setNinusiDokoGridData({
        data: createNinusiDokoCollectionView(荷主動向data, pageSize),
      })
      // 当月の情報を格納する
      set当月月次業績報告ID(res.data.当月実績.月次業績報告ID ?? 0)

      set当月月次業績報告更新日時(res.data.当月実績.更新日時)
      set報告テキスト１(res.data.当月実績.報告テキスト１ ?? "")
      set報告テキスト２(res.data.当月実績.報告テキスト２ ?? "")
      set報告テキスト３(res.data.当月実績.報告テキスト３ ?? "")
      set報告テキスト４(res.data.当月実績.報告テキスト４ ?? "")
      set報告テキスト５(res.data.当月実績.報告テキスト５ ?? "")
      // 月間集計管理の情報を格納する
      set月間集計管理ID(res.data.月間集計管理.月次集計管理ID)
      set月間集計管理テキスト(res.data.月間集計管理.予算実績タイトル)
      // 検索完了後に色々表示
      SetIsSearched(true)
    } catch (error) {
      dispatch(setAlerts(error))
      // 検索中にエラーがあった場合は非表示
      SetIsSearched(false)
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TBusyoBudgetAchievementlistGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBusyoBudgetAchievementlistGetReq => {
    return {
      年月: 年月 ?? undefined,
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TBusyoBudgetAchievementlistGetReq
  ) => {
    return {
      年月: dateUtil.format(searchCondition.年月, "YYYY/MM") ?? "",
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所名,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    // ヘッダー行の結合
    f.columnHeaders.rows.forEach((r) => {
      r.allowMerging = true
    })
  }

  /**
   * gridの行フォーマット作成用
   * @param i 数値
   * @param 項目 予算／実績／達成率
   * @return string
   */
  const cnvUriageStr = (i: number, 項目: string) => {
    if (項目 === "達成率") {
      return new Intl.NumberFormat("ja", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(i)
    } else {
      return new Intl.NumberFormat().format(i)
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認

      const detailItems: TNinusiDokoListPutReq[] = ninusiDokoGridData.data.items

      const data: TNinusiDokoListPutReq[] = []
      detailItems.forEach((r) => {
        data.push({
          主要荷主動向ID: r.主要荷主動向ID,
          主要荷主動向テキスト: r.主要荷主動向テキスト,
          更新日時: r.更新日時,
        })
      })

      const putdata: TBusyoBudgetAchievementlistPutReq = {
        月次業績報告ID: 当月月次業績報告ID,
        報告テキスト１: 報告テキスト１,
        報告テキスト２: 報告テキスト２,
        報告テキスト３: 報告テキスト３,
        報告テキスト４: 報告テキスト４,
        報告テキスト５: 報告テキスト５,
        更新日時: 当月月次業績報告更新日時,
        主要荷主動向: data,
      }

      const service = new sogoYusoKaigiService()

      let res: TApiResponse<boolean>
      res = await service.putBusyo(putdata)

      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        showInfoToast(`当月主要荷主動向の更新が完了しました`)
        await search(preSearchCondition)
      }
    } catch (error) {
      disPatch(setAlerts(error))
      showWarningToast("更新に失敗しました。")
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 部所予算実績帳票印刷処理
   */
  const printBusyoYosanZissekiReport = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition = createSearchCondition()
    let 年 = dayjs(currentSearchCondition.年月).year()
    let 月 = dayjs(currentSearchCondition.年月).month() + 1

    const printCondition: TSogoYusoKaigiPrintGetReq = {
      抽出条件_年: 年,
      抽出条件_月: 月,
      抽出条件_部所コード: 部所コード ?? "",
    }
    try {
      const res = await new sogoYusoKaigiService({
        responseType: "blob",
      }).printBusyoYosanZissekiReport(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // サマリ用グリッド
  const [summaryFlexGrid, setSummaryFlexGrid] = useState<wjGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })

  // 荷主動向グリッド
  const [ninusiDokoFlexGrid, setNinusiDokoFlexGrid] =
    useState<wjGrid.FlexGrid>()
  const [ninusiDokoGridData, setNinusiDokoGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()
  const [preSearchCondition, setPreSearchCondition] =
    useState<TBusyoBudgetAchievementlistGetReq>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  // 運行場所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  // 入力欄
  const [当月月次業績報告ID, set当月月次業績報告ID] = useState<number>(0)
  const [当月月次業績報告更新日時, set当月月次業績報告更新日時] =
    useState<string>()
  const [報告テキスト１, set報告テキスト１] = useState<string>("")
  const [報告テキスト２, set報告テキスト２] = useState<string>("")
  const [報告テキスト３, set報告テキスト３] = useState<string>("")
  const [報告テキスト４, set報告テキスト４] = useState<string>("")
  const [報告テキスト５, set報告テキスト５] = useState<string>("")

  // 月間集計管理
  const [月間集計管理ID, set月間集計管理ID] = useState<number>()
  const [月間集計管理テキスト, set月間集計管理テキスト] = useState<string>("")
  // 更新 処理用
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [pageInitialized, setPageInitialized] = useState<boolean>(false)
  const [isSearched, SetIsSearched] = useState<boolean>(false)

  // モーダル用
  const [isTitleEditModalShow, setIsTitleEditModalShow] =
    useState<boolean>(false)
  const [isEdited, setIsEdited] = useState<boolean>(false)
  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set年月(当営業日)
      setPageInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && pageInitialized && 部所ComboBox) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, pageInitialized, 部所ComboBox])

  useEffect(() => {
    document.title = `総合輸送会議　部所予算実績`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (isEdited && gridInitialized) {
      showInfoToast(`当月実績報告タイトルの更新が完了しました`)
      search(createSearchCondition())
      setIsEdited(false)
    }
  }, [isEdited, gridInitialized])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">総合輸送会議</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>

        <Row>
          <Col>
            <Card className="w-35rem">
              <Card.Body>
                <div>
                  <Link
                    to={
                      util.getMenuPath(
                        予算_実績メニューコード.総合輸送会議_予算実績
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button disabled={isSearching}>予算実績</Button>
                  </Link>
                  <Link
                    to={
                      util.getMenuPath(
                        予算_実績メニューコード.総合輸送会議_粗利益一覧
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button className="mx-2" disabled={isSearching}>
                      粗利益一覧
                    </Button>
                  </Link>
                  <Link
                    to={
                      util.getMenuPath(
                        予算_実績メニューコード.総合輸送会議_荷主売上一覧
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button disabled={isSearching}>荷主売上一覧</Button>
                  </Link>
                  <Link
                    to={
                      util.getMenuPath(
                        予算_実績メニューコード.総合輸送会議_部所予算実績
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button className="mx-2" disabled={true}>
                      部所予算実績
                    </Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-35rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <table className="w-100">
                      <tr>
                        <td>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-8rem">
                                <MonthInput
                                  id="年月"
                                  placeholder="年月"
                                  value={年月}
                                  setValue={set年月}></MonthInput>
                              </div>
                              <ComboBox.Busyo
                                placeholder="部所"
                                isLoadEnded={部所isLoadEnded}
                                setIsLoadEnded={set部所isLoadEnded}
                                isAllSelect={false}
                                isRequired={false}
                                itemsSource={部所ItemSource}
                                selectedValue={部所コード}
                                setSelectedValue={(v) => {
                                  set部所コード(v)
                                }}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                          </div>
                        </td>
                        <td className="text-end align-middle">
                          <Button
                            type="submit"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              search()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            検索
                          </Button>
                        </td>
                      </tr>
                    </table>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row className={isSearched ? "" : "d-none"}>
          <Row>
            <Col>
              {/* 合計カード */}
              <Card>
                <Spinner searching={isSearching}></Spinner>

                <Card.Body>
                  <Row>
                    <Col>
                      {/* 検索条件表示コンポーネント */}
                      <DisplaySearchConditionLabel
                        displaySearchCondition={displaySearchCondition}
                      />
                    </Col>
                  </Row>
                  <FlexGridOuter
                    flexGrid={summaryFlexGrid}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL
                    }
                    setFlexGrid={setSummaryFlexGrid}
                    gridData={summaryGridData}
                    setGridData={setSummaryGridData}
                    pageNumber={pageNumber}
                    gridId={`${gridId}_1`}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    isShowGridFooter={true}
                    isEnablePageSize={"hidden"}
                    isEnableExport={true}
                    isHiddenGridDataCount={true}
                    isShowGridRowPickupButton={false}
                    hasFilter={false}
                    gridProperties={{
                      allowMerging: wjGrid.AllowMerging.Cells,
                      frozenColumns: 2,
                    }}
                    headerComponent={
                      <div>
                        <Button
                          disabled={isSearching}
                          className="btn-done"
                          onClick={(e: any) => {
                            e.stopPropagation()
                            e.preventDefault()
                            printBusyoYosanZissekiReport()
                          }}>
                          <FontAwesomeIcon icon={faFileAlt} />
                          部所予算実績印刷
                        </Button>
                      </div>
                    }>
                    <wjrGrid.FlexGridColumn
                      binding="部所名"
                      width={80}
                      cssClass="dummy-header-cell"
                      allowMerging={true}
                      header="部所合計"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="項目"
                      width={80}
                      cssClass="dummy-header-cell"
                      header="項目"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="年間金額str"
                      width={110}
                      cssClass="read-only-cell number-col"
                      header="年間"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額４月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="４月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額５月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="５月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額６月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="６月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額７月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="７月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額８月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="８月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額９月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="９月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="上期金額str"
                      width={110}
                      cssClass="read-only-cell number-col"
                      header="上期"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１０月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="１０月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１１月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="１１月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１２月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="１２月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="１月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額２月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="２月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額３月str"
                      width={100}
                      cssClass="read-only-cell number-col"
                      header="３月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="下期金額str"
                      width={110}
                      cssClass="read-only-cell number-col"
                      header="下期"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </Card.Body>
              </Card>
              {/* 所有荷主売上一覧 */}
              <Card>
                <Spinner searching={isSearching}></Spinner>
                <Card.Body>
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={pageNumber}
                    gridId={`${gridId}_2`}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    isShowGridRowPickupButton={false}
                    isShowGridFooter={true}
                    isEnablePageSize={"hidden"}
                    isEnableExport={true}
                    isHiddenGridDataCount={true}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    gridProperties={{ frozenColumns: 2 }}>
                    <wjrGrid.FlexGridColumn
                      binding="荷主コード"
                      width={64}
                      cssClass="dummy-header-cell"
                      header="荷主"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="荷主名"
                      width={192}
                      cssClass="dummy-header-cell"
                      header="荷主"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="年間金額"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="年間"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額４月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="４月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額５月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="５月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額６月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="６月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額７月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="７月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額８月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="８月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額９月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="９月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="上期金額"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="上期"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１０月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="１０月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１１月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="１１月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１２月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="１２月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額１月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="１月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額２月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="２月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="金額３月"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="３月"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="下期金額"
                      width={96}
                      cssClass="read-only-cell number-col"
                      header="下期"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </Card.Body>
              </Card>
              {/* 所有荷主動向 */}
              <Card className="w-105rem">
                <Spinner searching={isSearching}></Spinner>

                <Card.Body>
                  <FlexGridOuter
                    flexGrid={ninusiDokoFlexGrid}
                    setFlexGrid={setNinusiDokoFlexGrid}
                    gridData={ninusiDokoGridData}
                    setGridData={setNinusiDokoGridData}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                    }
                    pageNumber={pageNumber}
                    gridId={`${gridId}_3`}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    isShowGridFooter={false}
                    isShowGridRowPickupButton={false}
                    hasFilter={false}
                    gridInitializedHandler={gridInitializedHandler}
                    gridProperties={{
                      isReadOnly: false,
                      headersVisibility: wjGrid.HeadersVisibility.Column,
                      keyActionTab: wjGrid.KeyAction.CycleOut,
                    }}>
                    <wjrGrid.FlexGridColumn
                      binding="荷主コード"
                      width={64}
                      isReadOnly={true}
                      cssClass="dummy-header-cell"
                      header="当月主要荷主動向"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="荷主略称1"
                      width={192}
                      isReadOnly={true}
                      cssClass="dummy-header-cell"
                      header="当月主要荷主動向"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="主要荷主動向テキスト"
                      width={990}
                      header="当月主要荷主動向"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>

                  <Table className="form-table-label-left">
                    <tbody>
                      <tr>
                        <th colSpan={2}>
                          {月間集計管理テキスト != null &&
                          月間集計管理テキスト !== ""
                            ? 月間集計管理テキスト
                            : "報告テキスト１"}
                          <Button
                            style={{ marginLeft: "4rem" }}
                            variant="waiting"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              setIsTitleEditModalShow(true)
                            }}>
                            予算実績タイトル更新
                          </Button>
                        </th>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <TextAreaInput
                            className="w-100"
                            style={{ height: "10rem" }}
                            id="報告テキスト１"
                            name="報告テキスト１"
                            value={報告テキスト１}
                            setValue={set報告テキスト１}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>
                          当月の見込みと当月、翌月の施策　※当月稼働状況、荷主毎の稼働状況と増収に向けた短期的施策
                        </th>
                        <th>増収に向けた施策（中期）、経費削減に向けた施策</th>
                      </tr>
                      <tr>
                        <td>
                          <TextAreaInput
                            className="w-50rem"
                            style={{ height: "5rem" }}
                            id="報告テキスト２"
                            name="報告テキスト２"
                            value={報告テキスト２}
                            setValue={set報告テキスト２}
                          />
                        </td>
                        <td>
                          <TextAreaInput
                            className="w-50rem"
                            style={{ height: "5rem" }}
                            id="報告テキスト３"
                            name="報告テキスト３"
                            value={報告テキスト３}
                            setValue={set報告テキスト３}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>車輌・乗務員増減と補充計画</th>
                        <th>取締役指示事項等</th>
                      </tr>
                      <tr>
                        <td>
                          <TextAreaInput
                            className="w-50rem"
                            style={{ height: "5rem" }}
                            id="報告テキスト４"
                            name="報告テキスト４"
                            value={報告テキスト４}
                            setValue={set報告テキスト４}
                          />
                        </td>
                        <td>
                          <TextAreaInput
                            className="w-50rem"
                            style={{ height: "5rem" }}
                            id="報告テキスト５"
                            name="報告テキスト５"
                            value={報告テキスト５}
                            setValue={set報告テキスト５}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="search-button">
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                更新
              </Button>
            </Col>
          </Row>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
      <UpdateGekkanSyukeiTextModal
        isShow={isTitleEditModalShow}
        setIsShow={setIsTitleEditModalShow}
        setIsEdited={setIsEdited}
        id={月間集計管理ID}
        text={月間集計管理テキスト}
        年月={年月 ?? 当営業日}></UpdateGekkanSyukeiTextModal>
    </>
  )
}

export default BusyoBudgetAchievement
